import styled from 'styled-components';

export const FloatingCircle = styled.div`
  position: fixed;
  bottom: 32px;
  right: 32px;
  width: 60px;
  height: 60px;
  background: rgb(204, 247, 247);
  border-radius: 50%;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2000;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-3px) scale(1.05);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  }

  svg {
    color: #2a7f8a;
    width: 28px;
    height: 28px;
  }
`;
export const EmbeddedContainer = styled.div`
  height: 100%;
  width: 100%;
  max-height: '100vh';
  overflow: 'auto';
  background: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey2 : theme.colorPalette.white};
  margin: 0 auto;
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
`;

export const WidgetContainer = styled.div`
  z-index: 1000;
  background-color: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey2 : theme.colorPalette.white};
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  overflow: hidden;
  border-radius: 8px;
`;

export const HeaderButtons = styled.div`
  display: flex;
  align-items: center;
  > button {
    margin: 0 5px;
  }
  img {
    vertical-align: -0.125em;
    margin-right: 0.25rem;
    margin-left: 0;
    padding-left: 0;
  }
`;
